import React from 'react';

const PageWrapper = ({ children, maxWidth = 860 }) => (
  <div className="px-3 sm:px-4 md:px-6 py-5 pb-12">
    <div className="w-full mx-auto" style={{ maxWidth }}>
      {children}
    </div>
  </div>
);

export const PageCard = ({ children }) => (
  <div className="rounded-2xl p-5 sm:p-6 md:p-8 card">{children}</div>
);

export const PageTitle = ({ children }) => (
  <h1 className="font-extrabold text-xl sm:text-2xl mb-5 pb-4 pl-4 text-main font-sora leading-snug border-b-theme border-l-4 border-l-[#4f8ef7]">
    {children}
  </h1>
);

export const SectionH2 = ({ children }) => (
  <h2 className="font-bold text-base sm:text-lg mt-6 mb-2.5 text-main font-sora leading-snug">
    {children}
  </h2>
);

export const Para = ({ children }) => (
  <p className="text-sm mb-2.5 text-sub leading-[1.85]">{children}</p>
);

export const BulletList = ({ items }) => (
  <ul className="pl-5 mb-2.5 list-disc">
    {items.map((item, i) => (
      <li key={i} className="text-sm mb-1 text-sub leading-[1.85]">{item}</li>
    ))}
  </ul>
);

export default PageWrapper;
